/* global jwt_decode */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'
import { getQueryParams } from '../../utils'
import { setAuthStatus, storeBearerToken, authenticate, storeUser } from '../../actions/actions'

export class Login extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loggedIn: false,
      loginCode: false
    }
    this.controller = AbortController ? new AbortController() : {}
    this.signal = this.controller.signal
  }

  refreshToken = () => {
    return false
  }

  getTokenRefreshTime = (bearerToken) => {
    if (bearerToken) {
      const decoded = jwt_decode(bearerToken)
      if (decoded) {
        const expiresAt = decoded.exp * 1000
        const now = Date.now()
        const FIVE_MINUTES = 300000
        const TEN_MINUTES = 600000
        const THIRTY_SECONDS = 30000
        const refreshIn = Math.max(THIRTY_SECONDS, Math.min(expiresAt - now - FIVE_MINUTES, TEN_MINUTES))

        if (refreshIn <= 0) throw new Error('token is expired')

        return refreshIn
      } else {
        throw new Error('Token is missing.')
      }
    }
  }

  validateBearerToken = (bearer) => {
    this.props.dispatch(setAuthStatus('undecided'))
    fetch('/api/v1/users/me', {
      method: 'GET',
      headers: {
        authorization: `Bearer ${bearer}`
      }
    }).then(res => {
      if (res.status === 200) {
        return res.json()
      } else {
        this.props.dispatch(setAuthStatus('unauthenticated'))
        return { _error: res.statusText }
      }
    }).then(user => {
      if (user._error) {
        console.error('ERROR', user)
        this.props.dispatch(setAuthStatus('unauthenticated'))
      } else {
        if (user.name) {
          this.props.dispatch(storeUser(user))
        }
        this.props.dispatch(storeBearerToken(bearer))
        this.props.dispatch(authenticate())
        this.props.dispatch(setAuthStatus('authenticated'))
      }
    })
  }

  validateLoginCode = () => {
    if (!this.state.loggedIn) {
      this.props.dispatch(setAuthStatus('undecided'))
      const loginCode = window.localStorage.getItem('smartitems_api_login_code')
      fetch(`/api/v1/users/login?login_code=${loginCode}`, {
        method: 'GET',
        signal: this.signal
      }).then(res => {
        if (res.status === 200) {
          return res.json()
        }
        return { _error: res.statusText }
      }).then(result => {
        const { bearerToken } = result
        if (bearerToken) {
          window.localStorage.setItem('smartitems_api_bearer_token', bearerToken)
          this.props.dispatch(storeBearerToken(bearerToken))
          this.props.dispatch(setAuthStatus('authenticated'))
          this.props.dispatch(authenticate())
          return bearerToken
        } else {
          this.props.dispatch(setAuthStatus('unauthenticated'))
          console.error('ERROR: ', result)
        }
      })
    }
  }

  componentWillUnmount () {
    this.controller.abort()
    window.clearInterval(this.refreshTokenTimer)
  }

  componentDidUpdate () {
    if (this.props.auth.authStatus === 'uninitiated') {
      const bearerToken = window.localStorage.getItem('smartitems_api_bearer_token') || this.props.auth.bearerToken || false
      if (bearerToken) {
        this.validateBearerToken(bearerToken)
      } else {
        this.props.dispatch(setAuthStatus('unauthenticated'))
      }
    }
  }

  componentDidMount () {
    const queryParams = getQueryParams(window)
    const bearerToken = window.localStorage.getItem('smartitems_api_bearer_token') || this.props.auth.bearerToken || false
    try {
      window.clearTimeout(this.refreshTokenTimer)
      const refreshIn = this.getTokenRefreshTime()
      this.refreshTokenTimer = window.setTimeout(this.refreshToken, refreshIn)
    } catch (err) {

    }
    if (this.props.auth.authStatus === 'uninitiated') {
      if (queryParams.login_code) {
        window.localStorage.removeItem('smartitems_api_login_code')
        window.localStorage.setItem('smartitems_api_login_code', queryParams.login_code)
        this.validateLoginCode()
      } else if (bearerToken) {
        this.validateBearerToken(bearerToken)
      } else {
        this.props.dispatch(setAuthStatus('unauthenticated'))
      }
    }
  }

  render () {
    const { loggedIn } = this.state
    const { functionality } = this.props
    let content = null
    if (functionality === 'logicOnly') {
      return content
    }
    if (!loggedIn) {
      content = (
        <section className={css.Login}>
          <a href={process.env.CAVEON_ID_LOGIN_URL} target='_self' className={css.a}>Login with Caveon ID</a>
        </section>
      )
    }
    return content
  }
}

const mapStateToProps = state => {
  const { auth } = state
  return {
    auth
  }
}

export default connect(mapStateToProps)(Login)



// WEBPACK FOOTER //
// /app/js/components/Login/index.js